import { render, staticRenderFns } from "./setup-church-member.vue?vue&type=template&id=07cf0918&"
import script from "./setup-church-member.vue?vue&type=script&lang=js&"
export * from "./setup-church-member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports